// First letters of the first two words, e.g. "Maria Fernanda Soto" -> "MF".
export const initialsOf = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0])
        .join('')
        .toUpperCase();
